'use client';

import { useAuth as useAuthHook } from '@/lib/hooks/useAuth';
import type { AuthContextType } from '@/lib/types/auth.types';
import { createContext, ReactNode, useContext } from 'react';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuthHook();

  const authValue: AuthContextType = {
    user: auth.user,
    isAuthenticated: !!auth.user,
    isLoading: auth.isLoading,
    login: auth.login,
    register: auth.register,
    logout: auth.logout,
    setAuthFromResponse: auth.setAuthFromResponse,
  };

  return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
